var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.960938 1.5H5.46094V6H0.960938V1.5ZM8.46094 1.5H12.9609V6H8.46094V1.5ZM0.960938 9H5.46094V13.5H0.960938V9ZM8.46094 11.25C8.46094 11.8467 8.69799 12.419 9.11995 12.841C9.5419 13.2629 10.1142 13.5 10.7109 13.5C11.3077 13.5 11.88 13.2629 12.3019 12.841C12.7239 12.419 12.9609 11.8467 12.9609 11.25C12.9609 10.6533 12.7239 10.081 12.3019 9.65901C11.88 9.23705 11.3077 9 10.7109 9C10.1142 9 9.5419 9.23705 9.11995 9.65901C8.69799 10.081 8.46094 10.6533 8.46094 11.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/categoryIcon.1aa79ea58c5217211284636d563de1dc.svg";
export { ForwardRef as ReactComponent };